import Vue from 'vue';
import WorkIconLabel from '@/components/global_components/icon/WorkIconLabel';
import WorkIconWrapper from '@/components/base_components/icons/WorkIconWrapper';
import WorkIcon from '@/components/global_components/icon/WorkIcon';

Vue.component('WIconLabel', WorkIconLabel);
Vue.component('WIconWrapper', WorkIconWrapper);
Vue.component('WIcon', WorkIcon);
